import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';

import Home from './Home';
import Equipments from './Equipments';
const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/equipments" element={<Equipments />} />
      </Routes>
    </Router>
  );
};

export default App;
